export default __webpack_public_path__ + "../staticImages/highlight-article.jpg";